import React from "react";
import { connect } from "react-redux";
import { Grid, Menu } from "semantic-ui-react";
import { bindActionCreators } from "redux";

import { loadReportList } from '../actions';

import TopNav from "../../common/containers/top-nav";
import ReportContainerList from "../containers/list";
import ModuleEnvPicker from "../../common/containers/module-env-picker";

const ReportHomePage = ({ loadReportList, history }) => {
    return (
        <Grid>
            <TopNav
                headerContent="Reports"
                headerIcon="file excel"
                subheader={`Manage periodic reporting`}
                extraButtons={() => (
                    <>
                        <Menu.Item
                            name="Stats"
                            icon="chart bar"
                            onClick={() => history.push('/report/review')}
                        />
                        <ModuleEnvPicker
                            moduleName="report"
                            onChange={() => {
                                loadReportList();
                            }}
                        />
                    </>
                )}
            />

            <Grid.Row>
                <Grid.Column mobile={16}>
                    <ReportContainerList />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({ loadReportList }, dispatch);

export default connect(null, mapDispatchToProps)(ReportHomePage);
